module.exports = __webpack_public_path__ + "img/values.b79417e9.jpg";